import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import Layout from './components/common/Layout';
import Login from './components/auth/Login';
import EmployeeList from './components/admin/EmployeeList';
import TaskList from './components/admin/TaskList';
import EmployeeDashboard from './components/employee/EmployeeDashboard';
import EmployeeTasks from './components/employee/EmployeeTasks';
import Salary from './components/employee/Salary';
import EmployeePersonalInfo from './pages/Employee/EmployeePersonalInfo';
// Groups feature removed
import LeaveApply from './pages/Employee/LeaveApply';
import LeaveList from './pages/Employee/LeaveList';
import EmployeeHolidays from './pages/Employee/EmployeeHolidays';
import EmployeeWorkUpdates from './pages/Employee/EmployeeWorkUpdates';
import Meetings from './pages/Employee/Meetings';
import CreateMeetingEmployee from './pages/Employee/CreateMeeting';
import EmployeePayslipPrint from './pages/Employee/EmployeePayslipPrint';
import AttendanceRequests from './pages/Employee/AttendanceRequests';
import ChangePassword from './pages/Common/ChangePassword';

import LeavesAdmin from './pages/Admin/LeavesAdmin';
import MeetingsAdmin from './pages/Admin/MeetingsAdmin';
import CreateMeeting from './pages/Admin/CreateMeeting';
import PaySalary from './pages/Admin/PaySalary';
import AdminDashboard from './pages/Admin/AdminDashboard';
import HolidayAdmin from './pages/Admin/HolidayAdmin';
import AttendanceRecord from './pages/Admin/AttendanceRecord';
import AdminEmployeeView from './pages/Admin/AdminEmployeeView';
import SalarySlipPrint from './pages/Admin/SalarySlipPrint';
import AttendanceManagement from './pages/Admin/AttendanceManagement';
import NotificationsAdmin from './pages/Admin/NotificationsAdmin';
import AdminWorkUpdates from './pages/Admin/AdminWorkUpdates';

import './App.css';

function App() {
  // Dev tools restriction removed as per user request

  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <AdminDashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/dashboard/attendence-record"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <AttendanceRecord />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/employees"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <EmployeeList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/employees/:id"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <AdminEmployeeView />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/employees/:id/pay-salary"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <PaySalary />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/leaves"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <LeavesAdmin />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/holidays"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <HolidayAdmin />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/meetings"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <MeetingsAdmin />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/meetings/create"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <CreateMeeting />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/attendance"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <AttendanceManagement />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/work-updates"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <AdminWorkUpdates />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/notifications"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <NotificationsAdmin />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tasks"
            element={
              <PrivateRoute requiredRole="admin">
                <Layout>
                  <TaskList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/dashboard"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <EmployeeDashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/personal-information"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <EmployeePersonalInfo />
                </Layout>
              </PrivateRoute>
            }
          />
          {/* Groups routes removed */}
          <Route
            path="/employee/leaves/apply"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <LeaveApply />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/leaves"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <LeaveList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/attendance/requests"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <AttendanceRequests />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/holidays"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <EmployeeHolidays />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/salary/print/:month/:year"
            element={
              <PrivateRoute requiredRole="employee">
                <EmployeePayslipPrint />
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/work-updates"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <EmployeeWorkUpdates />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/meetings"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <Meetings />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/meetings/create"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <CreateMeetingEmployee />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/me/change-password"
            element={
              <PrivateRoute>
                <Layout>
                  <ChangePassword />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/tasks"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <EmployeeTasks />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/salary"
            element={
              <PrivateRoute requiredRole="employee">
                <Layout>
                  <Salary />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/admin/print-slip/:employeeId/:month/:year"
            element={
              <PrivateRoute requiredRole="admin">
                <SalarySlipPrint />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
